// Deployment identity for the brand defaults.
//
// A support ADDRESS names one organization's mail domain, so it is deployment
// configuration rather than brand copy. This package has no build-time env of
// its own, so it reads the one runtime tier its browser consumers already have:
// `globalThis.__APP_CONFIG__`, which the portal container's entrypoint writes
// into /config.js before the bundle runs (see apps/user-portal/src/config/
// deployment.ts, which reads the same `supportEmail` key). Outside a browser —
// or when the key is unset or blank — the transitional default below applies.
//
// That default is the literal `brand.ts` carried before this module existed;
// it lives here and nowhere else in this package.
/** Transitional default. No LDS environment sets `supportEmail`; dev and qa both run on it. */
export const DEFAULT_SUPPORT_EMAIL = 'support@legaldocumentserver.com';
/** The support address for this deployment: the runtime value when it is a non-blank string, else the default. */
export function resolveSupportEmail(runtime = globalThis.__APP_CONFIG__) {
    const configured = runtime?.supportEmail;
    return typeof configured === 'string' && configured.trim().length > 0 ? configured.trim() : DEFAULT_SUPPORT_EMAIL;
}
